import stringHash from 'string-hash';

const getHashFromString = (input: string): number => stringHash(input);

export default getHashFromString;
